import React, { useEffect, useState } from "react";
import { useSelector, connect } from "react-redux";
import { LocalStorageService, toAbsoluteUrl } from "../../../services";
import Select from "react-dropdown-select";
import moment from "moment";

import {
  getAllCampaigns,
  getCampaignActivityData,
  dashboardCountsData,
  dashboardCampaignPieData,
  showLoader,
  dashboardCampaignCompetenciesData,
} from "../../../redux/actions/nrp/dashboardActions";
import { getCustomHeaders } from "../../../redux/actions/nrp/leaderboardActions";
import { listGetCustomHeaders } from "../../../redux/actions/nrp/listActions";

// Components
import {
  CheckBox,
  LineChart,
  DateRangePicker,
  CountCard,
  ProgressBar,
  PieChart,
  PieChartTabs,
  GuageMeter,
  RadialChart,
} from "../../components";

// Json Data
import {
  ChartOverviewData,
  ChartsTabsData,
  ChartsTabsData1,
  competenciesAssessments,
} from "./data";

// get step data from redux main state
const data = (state) => state.nrpDashboard;

// get step data from redux main state
const authData = (state) => state.auth;

function Dashboard(props) {
  let {
    campaigns,
    defaultCampaign,
    series,
    categories,
    campaignCountsData,
    pieChartData,
    assessmentData,
  } = useSelector(data);

  let { userType } = useSelector(authData);

  // state
  const [selectedCampaign, setselectedCampaign] = useState(null);
  const [chartOverview, setchartOverview] = useState([
    "Total Registration",
    "In Progress",
    "Completed",
    "Locked Users",
    "Only Registered",
  ]);
  const [startDate, setstartDate] = useState();
  const [endDate, setendDate] = useState();
  const [defaultStartDate, setDefaultStartDate] = useState();
  const [defaultEndDate, setDefaultEndDate] = useState();
  const [personalActive, setPersonalActive] = useState("byAreaOfInterest");
  const [educationActive, setEducationActive] = useState("byUniversity");
  const [showFooterPart, setShowFooterPart] = useState(false);

  // Functions

  let handleDropdown = (campaign) => {
    let { campaignId, createdAt, endDate } = campaign[0];
    setselectedCampaign(campaign);
    LocalStorageService.setObject("campaign", campaign);

    let campaignData = {
      startDate: createdAt,
      endDate: endDate,
      campaignId,
    };

    setstartDate(campaignData.startDate);
    setDefaultStartDate(campaignData.startDate);
    setDefaultEndDate(campaignData.endDate);
    setendDate(campaignData.endDate);

    LocalStorageService.remove("assessmentsFeilds");
    LocalStorageService.remove("customListAssessmentsFeilds");
    props.getCustomHeaders([]);
    props.listGetCustomHeaders([]);

    props.showLoader();
    props.getCampaignActivityData(campaignData, true);
    props.dashboardCountsData(campaignData);
    props.dashboardCampaignPieData(campaignData);
    props.dashboardCampaignCompetenciesData(campaignData);
  };

  let handelChartOverciew = (event) => {
    var updatedList = [...chartOverview];
    if (event.target.checked) {
      updatedList = [...chartOverview, event.target.value];
    } else {
      updatedList.splice(chartOverview.indexOf(event.target.value), 1);
    }
    setchartOverview(updatedList);
  };

  // Get Data By Date Fitler

  let getCampaginActivityDataByDate = (date) => {
    setstartDate(date[0]);
    setendDate(date[1]);
    let { campaignId } = selectedCampaign[0];
    let campaignData = {
      startDate: date[0],
      endDate: date[1],
      campaignId,
    };
    if (startDate || endDate) {
      props.getCampaignActivityData(campaignData);
      props.dashboardCountsData(campaignData);
      props.dashboardCampaignPieData(campaignData);
    } else {
      alert("Please Select Date!");
    }
  };

  useEffect(() => {
    props.getAllCampaigns();
  }, []);

  useEffect(() => {
    if (defaultCampaign) {
      let { campaignId, createdAt, endDate } = defaultCampaign[0];

      let campaignData = {
        startDate: createdAt,
        endDate: endDate,
        campaignId,
      };
      setstartDate(campaignData.startDate);
      setDefaultStartDate(campaignData.startDate);
      setDefaultEndDate(campaignData.endDate);
      setendDate(campaignData.endDate);

      props.getCampaignActivityData(campaignData);
      props.dashboardCountsData(campaignData);
      props.dashboardCampaignPieData(campaignData);
      props.dashboardCampaignCompetenciesData(campaignData);
      setselectedCampaign(defaultCampaign);
    }
  }, [defaultCampaign]);

  // All Console Data For Testing
  // console.log(series, " here is series");
  // console.log(categories, " here is categories");
  // console.log(startDate,"====> here is startDate")
  // console.log(endDate,"====> here is endDate")
  // console.log(campaignCountsData,'===> here is campaignCountsData')
  // console.log(pieChartData && pieChartData["education"]["byUniversity"],educationActive);
  // console.log(assessmentData,'===> djskkjdskhsd')

  return (
    <div>
      <div className="flex justify-end px-20 mb-10 ">
        {series &&
        categories &&
        campaignCountsData &&
        pieChartData &&
        campaigns ? (
          <Select
            style={{ width: 300, zIndex: 20 }}
            values={
              selectedCampaign != null ? selectedCampaign : defaultCampaign
            }
            searchable={false}
            options={campaigns}
            required={true}
            onChange={(values) => handleDropdown(values)}
            placeholder={"Selected Campaign"}
          />
        ) : null}
      </div>

      <div className="mx-auto 2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-11/12 mt-2 border border-[#BBBBBB70] rounded-md">
        <div className="bg-white rounded-md shadow-lg  py-8 w-full">
          {series && categories && campaignCountsData && pieChartData ? (
            <div>
              {/* Range Picker For Chart Start */}
              <DateRangePicker
                handelDateChange={getCampaginActivityDataByDate}
                startDate={moment(startDate).format("YYYY-MM-DD")}
                endDate={moment(endDate).format("YYYY-MM-DD")}
                defaultStartDate={moment(defaultStartDate).format("YYYY-MM-DD")}
                defaultEndDate={moment(defaultEndDate).format("YYYY-MM-DD")}
              />
              {/* Range Picker For Chart End */}

              {/* Main Chart Code Start */}
              <div className="2xl:px-16 xl:px-16 lg:px-16 px-8 flex items-start 2xl:flex-row xl:flex-row lg:flex-row flex-col 2xl:justify-between xl:justify-between lg:justify-between justify-center ">
                <div className="2xl:w-3/12 xl:w-3/12 lg:w-3/12 md:w-10/12 w-10/12 mt-5">
                  {ChartOverviewData &&
                    ChartOverviewData.map((item, i) => {
                      return (
                        <CheckBox
                          id={`chartOverview-${i}`}
                          key={i}
                          label={item.name}
                          value={item.key}
                          selected={chartOverview.includes(item.key)}
                          onChange={handelChartOverciew}
                        />
                      );
                    })}
                </div>

                <div className="2xl:w-9/12 xl:w-9/12 md:w-10/12 w-11/12">
                  {series && categories ? (
                    <LineChart
                      filter={chartOverview}
                      categories={categories}
                      series={series}
                    />
                  ) : (
                    <div className="flex justify-center items-center">
                      <img
                        src={toAbsoluteUrl("/media/nrp/dashboard/logo.gif")}
                        alt="TTG LOGO"
                        style={{
                          width: "100px",
                          height: "90px",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* Main Chart Code End */}
              {/* Total Count Start */}
              {campaignCountsData && campaignCountsData ? (
                <div className="flex justify-between items-center 2xl:flex-row xl:flex-row lg:flow-row md:flex-row  flex-col my-10 2xl:px-16 xl:px-16 lg:px-16 px-8 ">
                  <CountCard
                    bgColor="#E9EEF7"
                    iconUrl="registration.png"
                    title="Total Registrations"
                    count={campaignCountsData.users}
                  />
                  <CountCard
                    bgColor="#EDF2E7"
                    iconUrl="completed.png"
                    title="Completed Games"
                    count={campaignCountsData.completed}
                  />
                  <CountCard
                    bgColor="#FFEFE9"
                    iconUrl="inCompleted.png"
                    title="Incomplete Games"
                    count={campaignCountsData.inProgress}
                  />
                </div>
              ) : null}
              {/* Total Count End */}

              {/* Assessments  Start */}

              <div className="flex h-max 2xl:px-8 xl:px-8 lg:px-8 px-8 flex-row items-center justify-around flex-wrap">
                <div className="2xl:w-[48%] xl:w-[48%] lg:w-[48%] md:w-11/12 w-11/12 border-[#E8E8E8] border-[1px] bg-[#fff] shadow-lg px-6 py-4 ">
                  {" "}
                  <h4 className="text-[#121212] text-xl mb-4 font-bold">
                    Competency Assessments
                  </h4>
                  <div className="flex flex-row justify-between mb-4">
                    <div className="flex flex-row items-center">
                      <b className="text-[#F0CA00] text-xs font-bold">Min: </b>
                      <span className="text-[#FFD700]  text-xs font-medium  ml-1">
                        10th Percentile{" "}
                      </span>
                    </div>
                    <div className="flex flex-row items-center">
                      <p className="w-1 h-1 mr-2 rounded-full bg-[#9F9F9F]"></p>
                      <b className="text-[#007E8C]  text-xs font-bold">
                        Median:{" "}
                      </b>
                      <span className="text-[#007E8C]  text-xs font-medium  ml-1">
                        Median Score
                      </span>
                    </div>
                    <div className="flex flex-row items-center">
                      <p className="w-1 h-1 mr-2 rounded-full bg-[#9F9F9F]"></p>

                      <b className="text-[#F3AE00] text-xs font-bold">Max: </b>
                      <span className="text-[#F3AE00] text-xs font-medium ml-1">
                        90th Percentile
                      </span>
                    </div>
                  </div>
                  <div className="scroller overflow-y-auto h-[22rem]">
                    {assessmentData &&
                      assessmentData.competencies &&
                      assessmentData.competencies.map((item, i) => {
                        return (
                          <div key={i}>
                            <div className="flex flex-row items-center border-l-2 py-2 border-b-2 pl-2 ">
                              <div className="w-[8%]">
                                <img
                                  src={
                                    competenciesAssessments[item.title]
                                      ? competenciesAssessments[item.title]
                                          .imgSrc
                                      : toAbsoluteUrl(
                                          "/media/nrp/dashboard/planning.png"
                                        )
                                  }
                                  alt={item.name}
                                  style={{ width: "30px" }}
                                />
                              </div>
                              <div className="w-[32%]">
                                <p className="text-[#121212] text-xs">
                                  {competenciesAssessments[item.title]
                                    ? competenciesAssessments[item.title].title
                                    : item.title}
                                </p>
                              </div>

                              <div className="w-[60%] mr-4">
                                {item && item ? (
                                  <ProgressBar
                                    percetile_10={item.percetile_10}
                                    percetile_90={item.percetile_90}
                                    percetile_50={item.percetile_50}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div className="flex flex-row items-center mt-6">
                    <div className="w-[8%]"></div>
                    <div className="w-[32%]"></div>
                    <div className="w-[60%] mr-4">
                      <div className="flex flex-row justify-between">
                        <p className="text-xs mt-2 text-[#9C9C9C]">0</p>
                        <p className="text-xs  text-[#9C9C9C]">10</p>
                        <p className="text-xs  text-[#9C9C9C]">20</p>
                        <p className="text-xs  text-[#9C9C9C]">30</p>
                        <p className="text-xs  text-[#9C9C9C]">40</p>
                        <p className="text-xs  text-[#9C9C9C]">50</p>
                        <p className="text-xs  text-[#9C9C9C]">60</p>
                        <p className="text-xs  text-[#9C9C9C]">70</p>
                        <p className="text-xs  text-[#9C9C9C]">80</p>
                        <p className="text-xs  text-[#9C9C9C]">90</p>
                        <p className="text-xs  text-[#9C9C9C]">100</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="2xl:w-[48%] xl:w-[48%] lg:w-[48%] md:w-11/12 w-11/12 border-[#E8E8E8] border-[1px] bg-[#fff] shadow-lg px-6 py-4 2xl:mt-0 xl:mt-0 lg:mt-0 mt-2 ">
                  <h4 className="text-[#121212] text-xl mb-4 font-bold">
                    Cognitive Assessments
                  </h4>

                  <div className="flex flex-row  justify-between mb-4 ">
                    <div className="flex flex-row items-center">
                      <b className="text-[#F0CA00] text-xs font-bold">Min: </b>
                      <span className="text-[#FFD700]  text-xs font-medium  ml-1">
                        10th Percentile{" "}
                      </span>
                    </div>
                    <div className="flex flex-row items-center">
                      <p className="w-1 h-1 mr-2 rounded-full bg-[#9F9F9F]"></p>
                      <b className="text-[#007E8C]  text-xs font-bold">
                        Median:{" "}
                      </b>
                      <span className="text-[#007E8C]  text-xs font-medium  ml-1">
                        Median Score
                      </span>
                    </div>
                    <div className="flex flex-row items-center">
                      <p className="w-1 h-1 mr-2 rounded-full bg-[#9F9F9F]"></p>

                      <b className="text-[#F3AE00] text-xs font-bold">Max: </b>
                      <span className="text-[#F3AE00] text-xs font-medium ml-1">
                        90th Percentile
                      </span>
                    </div>
                  </div>

                  <div className="scroller overflow-y-auto h-[22rem]">
                    {assessmentData &&
                      assessmentData.cognitive &&
                      assessmentData.cognitive.map((item, i) => {
                        return (
                          <div key={i}>
                            <div className="flex flex-row items-center border-l-2 py-2 border-b-2 pl-2 ">
                              <div className="w-[8%]">
                                <img
                                  src={
                                    competenciesAssessments[item.title]
                                      ? competenciesAssessments[item.title]
                                          .imgSrc
                                      : toAbsoluteUrl(
                                          "/media/nrp/dashboard/planning.png"
                                        )
                                  }
                                  alt={item.name}
                                  style={{ width: "30px" }}
                                />
                              </div>
                              <div className="w-[32%]">
                                <p className="text-[#121212] text-xs">
                                  {competenciesAssessments[item.title]
                                    ? competenciesAssessments[item.title].title
                                    : item.title}
                                </p>
                              </div>

                              <div className="w-[60%] mr-4">
                                {item && item ? (
                                  <ProgressBar
                                    percetile_10={item.percetile_10}
                                    percetile_90={item.percetile_90}
                                    percetile_50={item.percetile_50}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div className="flex flex-row items-center mt-6">
                    <div className="w-[8%]"></div>
                    <div className="w-[32%]"></div>
                    <div className="w-[60%] mr-4">
                      <div className="flex flex-row justify-between">
                        <p className="text-xs mt-2 text-[#9C9C9C]">0</p>
                        <p className="text-xs  text-[#9C9C9C]">10</p>
                        <p className="text-xs  text-[#9C9C9C]">20</p>
                        <p className="text-xs  text-[#9C9C9C]">30</p>
                        <p className="text-xs  text-[#9C9C9C]">40</p>
                        <p className="text-xs  text-[#9C9C9C]">50</p>
                        <p className="text-xs  text-[#9C9C9C]">60</p>
                        <p className="text-xs  text-[#9C9C9C]">70</p>
                        <p className="text-xs  text-[#9C9C9C]">80</p>
                        <p className="text-xs  text-[#9C9C9C]">90</p>
                        <p className="text-xs  text-[#9C9C9C]">100</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Assessments  End */}

              {/* Pie Chart Start */}

              {userType !== "free" ? (
                <div className="my-6 flex 2xl:px-8 xl:px-8 lg:px-8 px-8 flex-row items-center justify-around flex-wrap">
                  <div className="2xl:w-[48%] xl:w-[48%] lg:w-[48%] md:w-11/12  w-11/12 border-[#E8E8E8] border-[1px] bg-[#fff] shadow-lg px-6 py-6 mb-4">
                    <div className="mb-6">
                      <h4 className="text-[#121212] text-lg  font-bold">
                        Education Demographics
                      </h4>
                      <p className="text-[#333333] text-sm">
                        Only Completed game played
                      </p>
                    </div>
                    <div className="flex flex-row flex-wrap items-center">
                      <PieChartTabs
                        active={educationActive}
                        handelPieTab={(e) => setEducationActive(e)}
                        list={ChartsTabsData && ChartsTabsData}
                      />
                      <PieChart
                        data={
                          pieChartData &&
                          pieChartData["education"][educationActive]
                        }
                      />
                    </div>
                  </div>
                  <div className="2xl:w-[48%] xl:w-[48%] lg:w-[48%] md:w-11/12  w-11/12 border-[#E8E8E8] border-[1px] bg-[#fff] shadow-lg px-6 py-6 mb-4">
                    <div className="mb-6">
                      <h4 className="text-[#121212] text-lg  font-bold">
                        Personal Data Demographics
                      </h4>
                      <p className="text-[#333333] text-sm">
                        Only Completed game played
                      </p>
                    </div>
                    <div className="flex flex-row flex-wrap items-center">
                      <PieChartTabs
                        active={personalActive}
                        handelPieTab={(e) => setPersonalActive(e)}
                        list={ChartsTabsData1 && ChartsTabsData1}
                      />
                      <PieChart
                        data={
                          pieChartData &&
                          pieChartData["personal"][personalActive]
                        }
                        width={400}
                      />
                    </div>
                  </div>
                </div>
              ) : null}

              {/* Pie Chart End */}

              <div className="comingSoon w-full px-10">
                <img
                  className="w-full"
                  src={toAbsoluteUrl("/media/nrp/dashboard/nps.png")}
                  alt="coming soon"
                />
              </div>

              {/* Footer Part Start */}

              {showFooterPart && (
                <div className="my-10 flex 2xl:px-8 xl:px-8 lg:px-8 px-8 flex-row items-start justify-around flex-wrap">
                  <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-11/12  w-11/12">
                    <p className="text-[#11263C] 2xl:w-[80%]  xl:w-[80%]  lg:w-[80%] md:w-[90%] w-full  text-sm text-center font-semibold">
                      How likely would you recommend to your friends to
                      participate in the Talent Games recruitment experience?
                    </p>

                    <div className="mt-6 flex flex-row justify-around items-start">
                      <div>
                        <p className="text-center text-[#466089] font-bold">
                          40
                        </p>
                        <GuageMeter />
                        <div className="flex  flex-row  justify-around  items-center mt-10 mb-10">
                          <div className="justify-center items-center flex  flex-col">
                            <img
                              style={{ width: 40, alignSelf: "center" }}
                              src={toAbsoluteUrl(
                                "/media/nrp/dashboard/detractors.png"
                              )}
                            />
                            <p className="text-[#5A5A5A] uppercase  ">
                              Detractors
                            </p>
                            <p>
                              <b>5 </b>
                              {`(${28})%`}
                            </p>
                          </div>
                          <div className="justify-center items-center flex  flex-col">
                            <img
                              style={{ width: 40, alignSelf: "center" }}
                              src={toAbsoluteUrl(
                                "/media/nrp/dashboard/passives.png"
                              )}
                            />
                            <p className="text-[#5A5A5A] uppercase">Passives</p>
                            <p>
                              <b>2 </b>
                              {`(${11}%)`}
                            </p>
                          </div>
                          <div className="justify-center items-center flex  flex-col">
                            <img
                              style={{ width: 40, alignSelf: "center" }}
                              src={toAbsoluteUrl(
                                "/media/nrp/dashboard/promoters.png"
                              )}
                            />
                            <p className="text-[#5A5A5A] uppercase">
                              promoters
                            </p>
                            <p>
                              <b>11</b>
                              {`(${61}%)`}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p className="text-center text-[#466089] font-bold mb-[-10px]">
                          Net Promoter Score
                        </p>
                        <RadialChart percentage={[50]} labels={["Net Score"]} />
                      </div>
                    </div>
                  </div>
                  <div className="2xl:w-[40%] xl:w-[40%] lg:w-[40%] md:w-11/12  w-11/12 2xl:mt-0 xl:mt-0 lg:mt-0 md:mt-0 mt-10">
                    <div className="bg-[#D7F8E8] px-24 py-4 justify-center items-center mb-4">
                      <p className="text-[#333333] font-medium text-center">
                        NUMBER OF CANDIDATE QUERIES RECEIVED
                      </p>
                      <p className="text-[#000000] text-2xl font-extrabold my-4 text-center">
                        323
                      </p>
                    </div>
                    <div className="bg-[#A3EEFFB0] px-24 py-4 justify-center items-center ">
                      <p className="text-[#000000] font-medium  text-center">
                        AVERAGE RESPONSE TIME PER QUERY
                      </p>
                      <p className="text-[#000000] font-extrabold text-2xl my-4 text-center">
                        3 Hrs
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Footer Part End */}
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <img
                src={toAbsoluteUrl("/media/nrp/dashboard/logo.gif")}
                alt="TTG LOGO"
                style={{
                  width: "100px",
                  height: "90px",
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getAllCampaigns,
  getCampaignActivityData,
  dashboardCountsData,
  dashboardCampaignPieData,
  showLoader,
  dashboardCampaignCompetenciesData,
  getCustomHeaders,
  listGetCustomHeaders,
})(Dashboard);
